import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import { Dispatch, SetStateAction } from 'react'
import { Reply } from '@mui/icons-material';
import { Entities } from './Entities';

export const DeleteRestoreDialog : React.FC<{idToDelete: number,
                                      showDeleteRestoreDialog : boolean[], setShowDeleteRestoreDialog : Dispatch<SetStateAction<boolean[]>>, 
                                      handleDeleteOrRestore: ((id : number, isDelete : boolean) => void),
                                      entity : Entities  }> = (props) => {

    const { idToDelete, handleDeleteOrRestore, showDeleteRestoreDialog, setShowDeleteRestoreDialog, entity } = props

    const handleTextInDialog = (entity : Entities) : String => {
      switch (entity) {
        case Entities.CUSTOMER: return 'rodzica'
        case Entities.MEAL: return 'posiłku'
        default: return 'obiektu'
      }
    }

    return (
    <>
      <Dialog
        open={showDeleteRestoreDialog[0]}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{"Czy na pewno chcesz wykonać tę akcję?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Ta akcja spowoduje ${showDeleteRestoreDialog[1] ? `zdezaktywowanie ` : `przywrócenie`} ${handleTextInDialog(entity)}.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" 
          color={`warning`} 
          startIcon={<DeleteIcon />} 
          onClick={() => {handleDeleteOrRestore(idToDelete, showDeleteRestoreDialog[1]); setShowDeleteRestoreDialog([false, false])}}>{`${showDeleteRestoreDialog[1] ? `Usuń` : `Przywróć`}`} </Button>
          <Button variant="outlined" 
          color={`warning`} 
          startIcon={<Reply />} 
          onClick={() => setShowDeleteRestoreDialog([false, false])}>Anuluj</Button>
        </DialogActions>
      </Dialog>
    </>
    )
}